"use strict";

exports.__esModule = true;
exports.convertToLowerCasing = void 0;

const convertToLowerCasing = message => {
  let lowerCasedObject = {};

  for (let key of Object.keys(message)) {
    lowerCasedObject[key] = typeof message[key] === 'string' ? `${message[key]}`.toLowerCase() : message[key];
  }

  return lowerCasedObject;
};

exports.convertToLowerCasing = convertToLowerCasing;